import React, { HTMLAttributes } from 'react';
import { Badge } from './styles';

interface BadgeProps extends HTMLAttributes<HTMLDivElement> {
  children: any;
}

function BadgeComponent({ children, ...rest }: BadgeProps) {
  return <Badge {...rest}>{children}</Badge>;
}

export default BadgeComponent;
